var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"view-dialog"},[_c('el-dialog',{attrs:{"title":_vm.dialogName,"visible":_vm.viewDialogShow,"width":"90%","before-close":_vm.dialogClose},on:{"update:visible":function($event){_vm.viewDialogShow=$event}}},[_c('div',{ref:"chart",staticStyle:{"height":"60vh","width":"100%","margin":"0 auto"},attrs:{"id":"myChart"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }